import type { GrowthOverviewGranularity } from "../const";
import type { GrowthOverviewPeriodMetric } from "../growthOverviewApiTypes";
import type { IGrowthOverviewPeriodCell } from "../types";

import { buildPeriodsFromSeries } from "./buildPeriods";

export const buildPeriodSeries = (
    series: GrowthOverviewPeriodMetric[] | undefined | null,
    granularity: GrowthOverviewGranularity,
): IGrowthOverviewPeriodCell[] => buildPeriodsFromSeries(series ?? [], granularity);
